// Cross-company location access requests.
//
// Incoming = asks aimed at the location the user is currently managing
// (their inbox). Outgoing = asks their own company has raised at somebody
// else's location. Both are kept because the same owner is on both sides
// of the relationship in a multi-location group.
export const FETCH_ACCESS_REQUESTS = 'FETCH_ACCESS_REQUESTS';
export const STORE_INCOMING_ACCESS_REQUESTS = 'STORE_INCOMING_ACCESS_REQUESTS';
export const STORE_OUTGOING_ACCESS_REQUESTS = 'STORE_OUTGOING_ACCESS_REQUESTS';

export const FETCH_PENDING_ACCESS_FOR_USERS =
  'FETCH_PENDING_ACCESS_FOR_USERS';
export const STORE_PENDING_ACCESS_FOR_USERS =
  'STORE_PENDING_ACCESS_FOR_USERS';

export const DECIDE_ACCESS_REQUEST = 'DECIDE_ACCESS_REQUEST';
